import { render } from "./NotificationWrapper.vue?vue&type=template&id=73755f5a"
import script from "./NotificationWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__